import styled from 'styled-components';
import { THEME } from '../../../../themes';
import { ASSETS } from '../../../../assets';

export const GoogleLogo = styled(ASSETS.GOOGLE_G_LOGO)`
  width: 28px;
  position: absolute;
  left: ${THEME.SPACING.BASE};
`;
